import { Preferences } from '@capacitor/preferences';
// Mobile storage dependency
import { Capacitor } from '@capacitor/core';

const ACCESS_TOKEN_KEY = 'access_token';
const REFRESH_TOKEN_KEY = 'refresh_token';

export const isMobile = () => Capacitor.isNativePlatform();

export const getToken = async (): Promise<string | null> => {
  if (isMobile()) {
    const { value } = await Preferences.get({ key: ACCESS_TOKEN_KEY });
    return value;
  }
  // Web behavior: Check session then local
  return sessionStorage.getItem(ACCESS_TOKEN_KEY) || localStorage.getItem(ACCESS_TOKEN_KEY);
};

export const getRefreshToken = async (): Promise<string | null> => {
  if (isMobile()) {
    const { value } = await Preferences.get({ key: REFRESH_TOKEN_KEY });
    return value;
  }
  return sessionStorage.getItem(REFRESH_TOKEN_KEY) || localStorage.getItem(REFRESH_TOKEN_KEY);
};

export const setTokens = async (accessToken: string, refreshToken: string) => {
  if (isMobile()) {
    await Preferences.set({ key: ACCESS_TOKEN_KEY, value: accessToken });
    await Preferences.set({ key: REFRESH_TOKEN_KEY, value: refreshToken });
  } else {
    // Web behavior matches existing logic (usually handled in login component, but good to have here)
    localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  }
};

export const clearTokens = async () => {
  if (isMobile()) {
    await Preferences.remove({ key: ACCESS_TOKEN_KEY });
    await Preferences.remove({ key: REFRESH_TOKEN_KEY });
  } else {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    sessionStorage.removeItem(ACCESS_TOKEN_KEY);
    sessionStorage.removeItem(REFRESH_TOKEN_KEY);
  }
};
